"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetUpload = AssetUpload;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const icons_1 = require("@ant-design/icons");
const react_intl_1 = require("react-intl");
const AssetUpload_style_1 = require("./AssetUpload.style");
function AssetUpload({ enqueueAssetFileForUpload }) {
    return ((0, jsx_runtime_1.jsx)(AssetUpload_style_1.StyledAssetUpload, { listType: "picture-card", showUploadList: false, customRequest: options => enqueueAssetFileForUpload(options.file), multiple: true, children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(icons_1.FileAddOutlined, { style: { fontSize: 32 } }), (0, jsx_runtime_1.jsx)("div", { className: "m-t-s", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "assets.buttons.upload.long" }) })] }) }));
}
